<template>
  <div class="is-flex">
    <div v-for="filter in filters" :key="filter.value" style="margin-right: 10px;">
      <p style="margin-bottom: 3px;">{{ filter.designator }}</p>
      <date-time @input="updateFilter(filter, $event)" :date="$route.query[filter.designator]" :show_time="false"></date-time>
    </div>
  </div>
</template>
<script>
import DateTime from '@/components/DateTime'
export default {
  name: 'date-filters',
  props: ['filters'],
  methods: {
    updateFilter (filter, value) {
      let query = { ...this.$route.query }
      query[filter.designator] = value == undefined ? undefined : value
      this.$router.push({ path: this.$route.path, query: query })
    }
  },
  components: {
    DateTime
  }
}
</script>
